import styled from 'styled-components';
import PropTypes from 'prop-types';

const Stack = styled.div.attrs(({ align, gap, justify }) => ({
  $align: align,
  $gap: gap,
  $justify: justify,
}))`
  align-items: ${({ $align }) => $align};
  display: flex;
  flex-flow: column nowrap;
  gap: ${({ $gap }) => $gap};
  justify-content: ${({ $justify }) => $justify};
`;

export default Stack;

Stack.propTypes = {
  align: PropTypes.oneOf(['center', 'end', 'start', 'stretch']),
  gap: PropTypes.string,
  justify: PropTypes.string,
};

Stack.defaultProps = {
  align: 'stretch',
  gap: undefined,
  justify: 'normal',
};
